import { Button, Notice } from "@sk/ui";
import { Component, type ReactNode } from "react";

/**
 * Garde-fou : une erreur dans un écran affiche un message et un bouton, jamais une page blanche.
 * La navigation du bas reste utilisable ; changer d'onglet efface l'erreur (prop `resetKey`).
 */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey: string }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override componentDidUpdate(prev: { resetKey: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.failed) this.setState({ failed: false });
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="sk-container" style={{ display: "grid", gap: 12 }}>
        <Notice tone="warning" role="alert">
          Cet écran a rencontré un problème. Tes données ne sont pas perdues.
        </Notice>
        <Button onClick={() => window.location.reload()}>Recharger</Button>
      </main>
    );
  }
}
